import SelectableInventorySnapshot from './SelectableInventorySnapshot';
export default SelectableInventorySnapshot;